import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { CloseIcon } from 'tdesign-icons-react';
import { Button, Image, Radio, Slider, Space } from 'tdesign-react';

import NovaDialog from '@/components/dialog';
import { AiImageReferenceNumber, AiImageReferenceType, AiImageReferenceTypeLabel, AiPrompt } from '@/interface/aigc';

import styles from './index.module.less';

interface IProps {
  value: AiPrompt;
  visible: boolean;
  options?: AiImageReferenceType[];
  onClose: () => void;
  onConfirm: (val: AiPrompt) => void;
}

const ReferenceDialog: React.FC<IProps> = ({
  value,
  visible,
  options = [
    AiImageReferenceType.AUTO,
    AiImageReferenceType.SW,
    AiImageReferenceType.CW,
  ],
  onClose,
  onConfirm,
}) => {
  const [referVal, setReferVal] = useState<AiPrompt>({ prompt: '' });

  useEffect(() => {
    setReferVal(value);
  }, [value]);

  const handleConfirm = () => {
    onConfirm(referVal);
    onClose();
  };

  const getHeader = () => (
    <div className={styles.title}>
      <div className={styles.left}>
        参考图片
      </div>
      <CloseIcon onClick={onClose} style={{ cursor: 'pointer' }} />
    </div>
  );

  const getFooter = () => (
    <div className={classNames('nova-modal-fixed-bottom-wrapper-end', styles.footer)}>
      <Radio.Group
        value={referVal?.referenceType || AiImageReferenceType.AUTO}
        defaultValue={AiImageReferenceType.AUTO}
        className={styles.radio}
        onChange={v => setReferVal(pre => ({ ...pre, referenceType: v as AiImageReferenceType }))}
      >
        {options.map(opt => (
          <Radio key={opt} value={opt}>{AiImageReferenceTypeLabel[opt]}</Radio>
        ))}
      </Radio.Group>
      <Space size={10}>
        <Button
          className="nova-info-button"
          size="medium"
          block
          onClick={handleConfirm}
        >
          保存
        </Button>
      </Space>
    </div>
  );

  const dialogConfig = {
    visible,
    className: styles.dialog,
    style: { padding: 0 },
    width: 'fit-content',
    height: 'fit-content',
    closeBtn: false,
    header: getHeader(),
    footer: getFooter(),
    destroyOnClose: true,
  };

  return (
    <NovaDialog dialogConfig={dialogConfig}>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.image}>
            <Image
              src={referVal?.image?.url?.url}
              fit="contain"
              style={{ width: '100%', height: '100%' }}
            />
          </div>
          {(referVal?.referenceType === AiImageReferenceType.CW
          || referVal?.referenceType === AiImageReferenceType.SW)
          && (
            <div className={styles.number}>
              {referVal?.referenceType === AiImageReferenceType.CW
                ? '形象参考强度'
                : '风格参考强度'}
              <div className={styles.slider}>
                <Slider
                  min={0}
                  max={100}
                  step={1}
                  marks={[0, 20, 40, 60, 80, 100]}
                  value={referVal?.referenceType === AiImageReferenceType.CW
                    ? (referVal?.cw ?? AiImageReferenceNumber[AiImageReferenceType.CW])
                    : (referVal?.sw ?? AiImageReferenceNumber[AiImageReferenceType.SW])}
                  onChange={v => setReferVal(pre => ({
                    ...pre,
                    [referVal?.referenceType === AiImageReferenceType.CW ? 'cw' : 'sw']: v as number,
                  }))}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </NovaDialog>
  );
};

export default ReferenceDialog;
